export default "__VITE_ASSET__QQygi319__"